module.exports = __webpack_public_path__ + "vue-app/img/ecoresponsabilite-en-small.5fd1f8a3.jpg";